"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WolfMotorMTADeclineText = void 0;
var journey_services_1 = require("@ferry/journey-services");
var WolfRenewalQuoteMTADeclineWordings_1 = require("./declineWordings/WolfRenewalQuoteMTADeclineWordings");
var WolfMTADeclineWordings_1 = require("./declineWordings/WolfMTADeclineWordings");
var WolfRenewalWindowMTADeclineWordings_1 = require("./declineWordings/WolfRenewalWindowMTADeclineWordings");
var WolfMotorMTADeclineText = /** @class */ (function () {
    function WolfMotorMTADeclineText(props) {
        this.uwCodesEligibleForReferral = ["UWW001", "UWW004", "UWW005", "UWW028", "UWW041", "UWW059"];
        this.props = props;
        var interaction = this.props.interaction;
        var isRenewalQuote = interaction.process === journey_services_1.INTERACTION_PROCESS_RENEWAL_PROPOSAL;
        var inRenewalWindow = interaction.uistate.renewalWindow;
        if (isRenewalQuote) {
            this.declineWordings = new WolfRenewalQuoteMTADeclineWordings_1.WolfRenewalQuoteMTADeclineWordings();
        }
        else if (inRenewalWindow) {
            this.declineWordings = new WolfRenewalWindowMTADeclineWordings_1.WolfRenewalWindowMTADeclineWordings();
        }
        else {
            this.declineWordings = new WolfMTADeclineWordings_1.WolfMTADeclineWordings();
        }
        var uwDeclines = [
            {
                key: "UWW000",
                decline: "both",
                softHardWording: "changeInDriversHistory"
            },
            {
                key: "UWW001",
                decline: "both",
                softWording: "changeInDriversAge",
                hardWording: "changeInDriversAge"
            },
            {
                key: "UWW002",
                decline: "both",
                softWording: "changeInDriversAge",
                hardWording: "changeInDriversAge"
            },
            {
                key: "UWW004",
                decline: "both",
                softHardWording: "changeInDriversHistory"
            },
            {
                key: "UWW005",
                decline: "both",
                softHardWording: "changeInDriversHistory"
            },
            {
                key: "UWW006",
                decline: "both",
                softHardWording: "changeInDriversHistory"
            },
            {
                key: "UWW007",
                decline: "both",
                softHardWording: "changeInDriversHistory"
            },
            {
                key: "UWW008",
                decline: "both",
                softHardWording: "changeInRisk"
            },
            {
                key: "UWW009",
                decline: "both",
                softHardWording: "changeInRisk"
            },
            {
                key: "UWW010",
                decline: "both",
                softHardWording: "changeInDriversHistory"
            },
            {
                key: "UWW012",
                decline: "both",
                softHardWording: "changeInDriversHistory"
            },
            {
                key: "UWW013",
                decline: "both",
                softHardWording: "changeInDriversHistory"
            },
            {
                key: "UWW015",
                decline: "both",
                softHardWording: "changeInDriversHistory"
            },
            {
                key: "UWW020",
                decline: "both",
                softHardWording: "changeInDriversHistory"
            },
            {
                key: "UWW021",
                decline: "both",
                softHardWording: "changeInDriversHistory"
            },
            {
                key: "UWW022",
                decline: "hard",
                hardWording: "changeInAddressHard"
            },
            {
                key: "UWW023",
                decline: "soft",
                softWording: "changeInCarDetailsSoft"
            },
            {
                key: "UWW024",
                decline: "soft",
                softWording: "changeInCarDetailsSoft"
            },
            {
                key: "UWW026",
                decline: "soft",
                softWording: "changeInCarDetailsSoft"
            },
            {
                key: "UWW027",
                decline: "both",
                softHardWording: "changeInRisk"
            },
            {
                key: "UWW028",
                decline: "soft",
                softWording: "changeInCarUsage"
            },
            {
                key: "UWW029",
                decline: "both",
                softWording: "defaultMessage",
                hardWording: "defaultMessage"
            },
            {
                key: "UWW030",
                decline: "both",
                softWording: "defaultMessage",
                hardWording: "defaultMessage"
            },
            {
                key: "UWW031",
                decline: "both",
                softWording: "defaultMessage",
                hardWording: "defaultMessage"
            },
            {
                key: "UWW032",
                decline: "both",
                softWording: "changeInCarDetailsSoft",
                hardWording: "changeInRiskHard"
            },
            {
                key: "UWW033",
                decline: "hard",
                hardWording: "changeInRiskHard"
            },
            {
                key: "UWW034",
                decline: "both",
                softHardWording: "changeInDriversHistory"
            },
            {
                key: "UWW035",
                decline: "both",
                softWording: "defaultMessage",
                hardWording: "defaultMessage"
            },
            {
                key: "UWW036",
                decline: "soft",
                softWording: "changeInCarDetailsSoft"
            },
            {
                key: "UWW037",
                decline: "soft",
                softWording: "changeInCarDetailsSoft"
            },
            {
                key: "UWW038",
                decline: "soft",
                softWording: "changeInCarDetailsSoft"
            },
            {
                key: "UWW041",
                decline: "soft",
                softHardWording: "changeInDriversHistory"
            },
            {
                key: "UWW042",
                decline: "both",
                softHardWording: "changeInDriversHistory"
            },
            {
                key: "UWW043",
                decline: "hard",
                hardWording: "changeInAddressHard"
            },
            {
                key: "UWW044",
                decline: "soft",
                softWording: "changeInCarDetailsSoft"
            },
            {
                key: "UWW045",
                decline: "both",
                softWording: "defaultMessage",
                hardWording: "defaultMessage"
            },
            {
                key: "UWW046",
                decline: "both",
                softWording: "defaultMessage",
                hardWording: "defaultMessage"
            },
            {
                key: "UWW047",
                decline: "both",
                softWording: "defaultMessage",
                hardWording: "defaultMessage"
            },
            {
                key: "UWW048",
                decline: "both",
                softWording: "defaultMessage",
                hardWording: "defaultMessage"
            },
            {
                key: "UWW049",
                decline: "soft",
                softWording: "changeInRiskSoft"
            },
            {
                key: "UWW050",
                decline: "both",
                softHardWording: "changeInRisk"
            },
            {
                key: "UWW051",
                decline: "both",
                softWording: "defaultMessage",
                hardWording: "defaultMessage"
            },
            {
                key: "UWW052",
                decline: "both",
                softWording: "defaultMessage",
                hardWording: "defaultMessage"
            },
            {
                key: "UWW053",
                decline: "both",
                softHardWording: "changeInRisk"
            },
            {
                key: "UWW054",
                decline: "both",
                softHardWording: "changeInDriversHistory"
            },
            {
                key: "UWW055",
                decline: "both",
                softWording: "defaultMessage",
                hardWording: "defaultMessage"
            },
            {
                key: "UWW056",
                decline: "both",
                softHardWording: "changeInDriversHistory"
            },
            {
                key: "UWW057",
                decline: "both",
                softWording: "defaultMessage",
                hardWording: "defaultMessage"
            },
            {
                key: "UWW058",
                decline: "hard",
                hardWording: "changeInAddressHard"
            },
            {
                key: "UWW059",
                decline: "soft",
                softWording: "changeInCarDetailsSoft"
            },
            {
                key: "UWW060",
                decline: "soft",
                softWording: "mtaLimitReached"
            },
            {
                key: "UWW061",
                decline: "soft",
                softWording: "mtaLimitReached"
            },
            {
                key: "UWW062",
                decline: "soft",
                softWording: "mtaLimitReached"
            },
            {
                key: "UWW063",
                decline: "soft",
                softWording: "mtaLimitReached"
            },
            {
                key: "PVE03",
                decline: "error",
                errorWording: "calculationHalted"
            }
        ];
        this.underwritingResultCustomerWordings = [];
        for (var _i = 0, uwDeclines_1 = uwDeclines; _i < uwDeclines_1.length; _i++) {
            var uwDecline = uwDeclines_1[_i];
            var baseObj = {
                key: uwDecline.key,
                value: "",
                declineType: uwDecline.decline === "soft" ? "soft" : "hard",
                showReferral: this.uwCodesEligibleForReferral.includes(uwDecline.key)
            };
            if (uwDecline.decline === "both") {
                var softWordingBase = uwDecline.softHardWording ? uwDecline.softHardWording + "Soft" : uwDecline.softWording + "";
                this.underwritingResultCustomerWordings.push(__assign(__assign({}, baseObj), { value: this.declineWordings[softWordingBase], declineType: "soft" }));
                var hardWordingBase = uwDecline.softHardWording ? uwDecline.softHardWording + "Hard" : uwDecline.hardWording + "";
                this.underwritingResultCustomerWordings.push(__assign(__assign({}, baseObj), { value: this.declineWordings[hardWordingBase], declineType: "hard" }));
            }
            else if (uwDecline.decline === "error") {
                var errorWordingBase = uwDecline.errorWording + "";
                this.underwritingResultCustomerWordings.push(__assign(__assign({}, baseObj), { value: this.declineWordings[errorWordingBase], declineType: "error" }));
            }
            else {
                var wordingBase = uwDecline.softWording ? uwDecline.softWording + "" : uwDecline.hardWording + "";
                this.underwritingResultCustomerWordings.push(__assign(__assign({}, baseObj), { value: this.declineWordings[wordingBase] }));
            }
        }
    }
    return WolfMotorMTADeclineText;
}());
exports.WolfMotorMTADeclineText = WolfMotorMTADeclineText;
//# sourceMappingURL=WolfMotorMTADeclineText.js.map